import React, { createContext, useContext, useMemo, useState } from 'react';

const AnalyticsBotContext = createContext();

export const useAnalyticsBot = () => {
  const context = useContext(AnalyticsBotContext);
  if (!context) {
    throw new Error('useAnalyticsBot must be used within AnalyticsBotProvider');
  }
  return context;
};

export const AnalyticsBotProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);

  const openBot = () => {
    setIsOpen(true);
    setIsMinimized(false);
  };

  const closeBot = () => {
    setIsOpen(false);
    setIsMinimized(false);
  };

  const toggleBot = () => {
    if (isOpen && !isMinimized) {
      setIsMinimized(true);
    } else if (isMinimized) {
      setIsMinimized(false);
      setIsOpen(true);
    } else {
      setIsOpen(true);
    }
  };

  const minimizeBot = () => {
    setIsMinimized(true);
  };

  const addMessage = (message) => {
    setChatHistory(prev => [...prev, message]);
  };

  const clearHistory = () => {
    setChatHistory([]);
  };

  const value = useMemo(() => ({
    isOpen,
    isMinimized,
    chatHistory,
    openBot,
    closeBot,
    toggleBot,
    minimizeBot,
    addMessage,
    clearHistory,
    setChatHistory
  }), [isOpen, isMinimized, chatHistory]);

  return (
    <AnalyticsBotContext.Provider value={value}>
      {children}
    </AnalyticsBotContext.Provider>
  );
};
